import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const PeerGamingApiSlice = createApi({
	reducerPath: 'peergamingApi',
	baseQuery: fetchBaseQuery({
		baseUrl: import.meta.env.VITE_API_URL,
		prepareHeaders(headers) {
			headers.set(
				'x-pg-api-key',
				'$2a$11$OiMi.M/NFHy3oBqACKVR4eGOYLhpjpVuddxK1JVDo2u4a9sOcHphC'
			);
			return headers;
		}
	}),
	tagTypes: [
		'Games',
		'Platforms',
		'Reviews',
		'Highlights',
		'ProfileIcons',
		'Player',
		'PlayerPlatforms',
		'PlayerGames',
		'PlayerSocials',
		'Socials',
		'Stories',
		'User'
	],
	endpoints: () => ({})
});
